/**
 * This is a container for all route handlers. It can be simple and
 * dumb as is (passes route params down to RouteHandler),
 * but allows for an extra layer of control over all nested routes in needed.
 */

/**
 * Dependencies
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get } from 'lodash';
import { Route, Switch } from 'react-router';
import { Tracking as nwTracking } from '@nerdwallet/nw-client-lib';
import SearchRoute from './search-route';

class Container extends Component {
  componentDidMount() {
    // Fire logPageView on first load to get the previous path variable set up
    nwTracking.logPageView(this.props.location.pathname);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    // Log the page view when the route changes.
    if (this.props.location.pathname !== nextProps.location.pathname) {
      // TODO: Move the error handling on nw-client-lib.
      nwTracking.logPageView(nextProps.location.pathname);
    }
  }

  render() {
    const currentMatchPath = get(this.props, 'match.path');
    return (
      <div className="route-container">
        <Switch>
          <Route
            exact
            path={`${currentMatchPath}/results`}
            component={SearchRoute}
          />
        </Switch>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.displayName = 'RouteContainer';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.propTypes = {
  location: PropTypes.object,
};

export default Container;
